import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AdminAuthProvider } from "@/context/AdminAuthContext";

import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminArticles from "@/admin/AdminArticles";
import AdminArticleEditor from "@/admin/AdminArticleEditor";
import AdminLeads from "@/admin/AdminLeads";
import AdminSubscribers from "@/admin/AdminSubscribers";
import AdminContractors from "@/admin/AdminContractors";
import AdminDiscussions from "@/admin/AdminDiscussions";
import AdminMarkets from "@/admin/AdminMarkets";
import AdminNewsroom from "@/admin/AdminNewsroom";
import AdminTopicIdeas from "@/admin/AdminTopicIdeas";
import AdminCompetitorGaps from "@/admin/AdminCompetitorGaps";
import AdminCategories from "@/admin/AdminCategories";
import AdminBriefs from "@/admin/AdminBriefs";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <AdminAuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="articles" element={<AdminArticles />} />
              <Route path="articles/new" element={<AdminArticleEditor />} />
              <Route path="articles/:slug/edit" element={<AdminArticleEditor />} />
              <Route path="contractors" element={<AdminContractors />} />
              <Route path="discussions" element={<AdminDiscussions />} />
              <Route path="markets" element={<AdminMarkets />} />
              <Route path="newsroom" element={<AdminNewsroom />} />
              <Route path="topic-ideas" element={<AdminTopicIdeas />} />
              <Route path="competitor-gaps" element={<AdminCompetitorGaps />} />
              <Route path="briefs" element={<AdminBriefs />} />
              <Route path="categories" element={<AdminCategories />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="subscribers" element={<AdminSubscribers />} />
            </Route>

            <Route path="/" element={<Navigate to="/admin/login" replace />} />
            <Route path="*" element={<Navigate to="/admin/login" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AdminAuthProvider>
    </HelmetProvider>
  );
}

export default App;
